<template>
 <main role="main">
   <section class="banner">
        <!-- wrap-->
        <div class="container-fluid px-6">
          <div class="row flex-lg-row-reverse align-items-center g-5 py-5">
            <div class="col-lg-6">
              <div class="ratio ratio-16x9">
                <!--iframe.embed-responsive.item(src="https://www.youtube.com/watch?v=cY9iHC2JRKA" allowfullscreen)-->
                  <iframe src="https://www.youtube.com/embed/cY9iHC2JRKA" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            </div>
            <div class="col-lg-6 bannertext">
              <h1 class="display-5 fw-bold lh-1 mb-3">CultureLabs Platform</h1>
              <p class="lead">Recipes for Social Innovation</p>
              <p>The CultureLabs platform aims to systematise and spread knowledge about participatory projects in the field of cultural heritage and beyond. Through its functionalities and the variety of content it provides, it aspires to become a single point of reference for those who wish to organize participatory projects by taking advantage of digital technologies through a human rights lens. Dive in to discover helpful material from previous good practices and contribute your own “ingredients” and “recipes”!</p>
              <div class="d-grid gap-2 d-md-flex justify-content-md-start banneraction"> <router-link
                :to="{ name: 'recipeAdd' }" >Get Started </router-link><span>or</span><router-link
                :to="{ name: 'aboutUs' }" >Learn more about CultureLabs</router-link></div>
            </div>
          </div>
        </div>
    </section>


    <section class="featuredrecipes featured">
        <!-- wrap-->
        <div class="container-fluid px-6">
          <!-- heading-->
          <div class="heading">
            <h2>Featured Recipes</h2><span>A recipe is a structure that captures the “how” and the “inside” knowledge of a participatory project. Discover our selected recipes representing past good practices and ideas for new projects! Want to see more? Browse all our <router-link
                :to="{ name: 'PublicAssets' }">public recipes</router-link>.</span>
          </div>
          <!-- featured list-->
          <div class="featuredwrap">
            <VueSlickCarousel v-if="recipes.length > 0" ref="recipes-carousel" class="list" :dots="true" :variableWidth="true" :infinite="true" :centerMode="false" :accessibility="false" :focusOnSelect="true"
               :key="refresh">
            <div v-for="recipe in recipes" v-bind:key="recipe.id">
              <FeaturedRecipeCard
                v-bind:recipe="recipe">
              </FeaturedRecipeCard>
                </div>
               <template #prevArrow>
                 <a class='a-left control-c prev slick-prev'><img src="static/img/ic-triangle-left.png"/></a>
              </template>
                <template #nextArrow>
              <a class='a-left control-c next slick-next'><img src="static/img/ic-triangle-right.png"/></a>
            </template>
           </VueSlickCarousel>
          </div>
        </div>
      </section>

     <section class="featuredingredients featured">
       <div class="container-fluid px-6">
          <!-- heading-->
          <div class="heading">
           <h2>Featured Ingredients</h2><span>Ingredients are digital assets coming in different formats (documents, images, links to websites, video, etc) that can be helpful  in the context of participatory projects. Discover our rich variety of ingredients, from policy papers and co-creation methodologies to digital tools and exhibitions!
             Want to see more? Browse all our <router-link
                :to="{ name: 'PublicAssets', params: { preselect: 'ingredients'} }">public ingredients</router-link>.
           </span>
          </div>
          <!-- featured list-->
          <div class="featuredwrap">
            <VueSlickCarousel  v-if="resources.length > 0" ref="resources-carousel" class="list" :dots="true" :variableWidth="true" :infinite="true" :centerMode="false" :accessibility="false" :focusOnSelect="true"
               :key="refreshres">
            <div v-for="resource in resources"  v-bind:key="resource.id">
              <FeaturedIngredientsCard
                v-bind:resource="resource">
              </FeaturedIngredientsCard>
                </div>
               <template #prevArrow>
                 <a class='a-left control-c prev slick-prev'><img src="static/img/ic-triangle-left.png"/></a>
              </template>
                <template #nextArrow>
              <a class='a-left control-c next slick-next'><img src="static/img/ic-triangle-right.png"/></a>
            </template>
           </VueSlickCarousel>
          </div>
        </div>
      </section>
     
     <section class="getstarted">
        <!-- wrap-->
        <div class="container-fluid px-6">
          <div class="row flex-lg-row-reverse align-items-center">
            <div class="col-lg-8 right">
              <ul class="features row"> 
                <li class="col-md-6"> 
                  <div class="feat"> <img src="static/img/ic-feature-discover.png">
                    <div class="explanation">
                      <h2>Discover </h2>
                      <p>Discover information about participatory projects for social innovation in the field of Cultural Heritage and beyond. Find out not only successful outcomes but also the "inside" information.</p>
                    </div>
                  </div>
                </li>
                <li class="col-md-6">
                  <div class="feat"> <img src="static/img/ic-feature-create.png">
                    <div class="explanation">
                      <h2>Create </h2>
                      <p>Document and structure participatory projects as recipes. Upload helpful resources as ingredients. Make them public so that others can benefit from that knowledge.</p>
                    </div>
                  </div>
                </li>
              </ul>
              <ul class="features row">
                <li class="col-md-6">
                  <div class="feat"> <img src="static/img/ic-feature-collaborate.png">
                    <div class="explanation">
                      <h2>Collaborate </h2>
                      <p>Share your projects and resources with other users, ask for feedback, and collaborate with them on common projects. Find potential collaborators and get involved in projects of other organisations.</p>
                    </div>
                  </div>
                </li>
                <li class="col-md-6">
                  <div class="feat"> <img src="static/img/ic-feature-reuse.png">
                    <div class="explanation">
                      <h2>Reuse </h2>
                      <p>Copy an existing project and customise it to your own needs. Reuse and combine resources uploaded by others and complement them with your own material in order to build a new participatory project.</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-lg-4 left">
              <h1>Get started</h1>
              <p>Participatory projects are not (only) about impressive outcomes but also about the process that was followed, the experience that was gained, and about self-reflection. This is what a “recipe” aims to capture. Structure your experience from past projects or your ideas for new projects as recipes, upload helpful material, and share them with others, so as to boost knowledge about social innovation in cultural heritage and beyond! </p>
              <div class="justify-content-md-start"><router-link title="Sign in to your account" :to="{name: 'login'}" v-b-tooltip.hover.bottom>Sign in</router-link><span> or </span><router-link title="Sign up" :to="{name: 'signup'}" v-b-tooltip.hover.bottom>Sign up</router-link> to get started</div>
            </div>
          </div>
        </div>
      </section>

    <section class="text-white text-center pt-lg-5 pb-lg-5" id="tools" v-if="false">
      <!-- More tools: by default this section is not rendered -->
      <b-container>
        <div>
          <h2 class="mb-4">
            <b-link :href="links.forumUrl" style="color:white" target="_blank">
              Contribute with your ideas (Forum)
            </b-link>
          </h2>
          <h2 class="mb-4">
            <b-link :href="links.culturalHeritageUrl" style="color:white" target="_blank">
              Creative interaction with Cultural Heritage (WITH)
            </b-link>
          </h2>
          <h2 class="mb-4">
            <b-link :href="links.wotifyUrl" style="color:white" target="_blank">
              Experiment with co-creation tools (Wotify)
            </b-link>
          </h2>
        </div>
      </b-container>
    </section>
   
 </main>
</template>

<script>
import FeaturedRecipeCard from '../components/recipes/FeaturedRecipeCard'
import FeaturedIngredientsCard from '../components/resources/FeaturedIngredientsCard'
import Footer from '../components/Footer'
import SearchPlugin from '../plugins/SearchPlugin'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'home',
  components: {
    VueSlickCarousel,
    FeaturedRecipeCard,
    FeaturedIngredientsCard,
    Footer
  },
  data () {
    return {
      refresh: 0,
      refreshres: 0,
      links: {
        'forumUrl': 'https://www.phpbb.com/demo/',
        'culturalHeritageUrl': 'hhttp://withculture.eu',
        'wotifyUrl': 'https://wotify.co/'
      },
      recipes: [],
      recipesPagination: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 8
      },
      resources: [],
      resourcesPagination: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 8
      },
      settings: {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        centerMode: false,
        variableWidth: true,
        responsive: [
        {
            breakpoint: 1024,
            settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1
            }
        }]
      }
    }
  },
  created () {
    // get featured recipes
    this.getFeaturedRecipes()
    this.getFeaturedResources()
  },
  beforeMount () {
    SearchPlugin.event.$on('updateterm', this.changeTerm)
    SearchPlugin.event.$on('showView', this.showView)
  },
  computed: {
    showRecipePagination: function () {
      return this.recipesPagination.totalCount > this.recipesPagination.pageSize
    },
    showResourcePagination: function () {
      return this.resourcesPagination.totalCount > this.resourcesPagination.pageSize
    }
  },
  methods: {
    globalSearchHome () {
      this.search = 'global'
      this.showAll()
    },
    /*scrollTo (refName) {
      let element = this.$refs[refName]
      let top = element.offsetTop
      window.scrollTo(0, top)
    },*/
    initFeaturedRecipes: function () {
      this.recipes = []
    },
    getFeaturedRecipes: function () {
      // Fetch the list of featured recipes
      let params = {
        status: 'FEATURED',
        start: this.recipesPagination.pageSize * (this.recipesPagination.currentPage - 1),
        count: this.recipesPagination.pageSize
      }
      // get data
      let tempRecipes = []
      this.$store.dispatch('getRecipesList', params).then(
        data => {
          // this.tempRecipes = data.results
          this.recipesPagination.totalCount = data.totalCount
          this.initFeaturedRecipes()
          this.recipes = data.results
          this.refresh++;
          // get resource for each recipe
          // tempRecipes.forEach(
          //   recipe => {
          //     let temp = recipe
          //     this.$store.dispatch('getResourceEntity', temp.imageResource).then(
          //       resource => {
          //         temp.resource_url = resource.url
          //         temp.isShared = false
          //         this.recipes.push(temp)
          //       })
          //   }
          // )
        })
    },
    initFeaturedResources: function () {
      this.resources = []
    },
    getFeaturedResources: function () {
      // Fetch the list of featured resources
      let params = {
        status: 'FEATURED',
        start: this.resourcesPagination.pageSize * (this.resourcesPagination.currentPage - 1),
        count: this.resourcesPagination.pageSize
      }
      // get data
      this.$store.dispatch('getResourcesList', params).then(
        data => {
          this.resourcesPagination.totalCount = data.totalCount
          this.initFeaturedResources()
          this.resources = data.results
          this.refreshres++;
        })
    },
    changeTerm (val) {
      this.sTerm = val
    },
    showAll: function (token) {
      this.$search.searchNow()
    },
    showSearch: function () {
      this.$search.toggleSearch()
    },
    showView: function (event) {
      if (this.search === 'global') {
        if (event.detail.type === 'Organisation') {
          this.$router.push({name: 'organizationView', params: {id: event.detail.id}})
        } else if (event.detail.type === 'Recipe') {
          this.$router.push({name: 'recipeView', params: {id: event.detail.id}})
        } else if (event.detail.type === 'Resource') {
          this.$router.push({name: 'resourceView', params: {id: event.detail.id}})
        }
        this.search = ''
      }
    },
    searchCategory: function (cat_type, token) {
      this.$search.searchNow({
        resulttype: cat_type,
        token: token
      }
      )
    },
    searchTerm: function (term, relttype, token) {
      this.$search.searchNow({
        term: term,
        resulttype: resulttype,
        token: token
      }
      )
    }
  }
}
</script>

<style scoped>
  #services, #tools {
    background-color: #1d809f !important;
  }

  .recipe-container, .resource-container {
    border: 1px solid #eeeff0;
    min-width: 240px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue